<template>
  <AuthForm>
    <template v-slot:header>
      <div v-if="sent">
        <h2 v-translate>Request access has been sent</h2>
        <p>{{ successMsg }}</p>
      </div>
      <div v-else>
        <h2 v-translate>Publication accessible uniquement avec login autorisé</h2>
      </div>
    </template>

    <form v-if="!sent" class="col-md-12" role="form" @submit.prevent="$refs.requestAccessModal.show()">
      <error-messages :errors="errors"></error-messages>
      <p class="trusted">{{ publicationAccessParameters.private_no_access_message[$language.current] }}</p>
      <div class="submit">
        <div class="col-md-3">
          <input type="submit" :value="titles.send" />
        </div>
      </div>
    </form>

    <b-modal hide-header hide-footer lazy body-class="p-0" ref="requestAccessModal">
      <div class="modal-body login-form-content">
        <h2 v-translate>Enter your message</h2>
        <div>
          <form role="form" @submit.prevent="requestAccess" id="custom_message">
            <textarea
              rows="4"
              class="form-control"
              cols="50"
              name="custom_message"
              form="custom_message"
              v-model="customMessage"
            ></textarea>
            <error-messages :errors="errors"></error-messages>
            <div class="submit">
              <input type="submit" :value="titles.valid" />
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </AuthForm>
</template>

<script>
import appUrl from 'lib/appUrl.js';
import { publicationAccessParameters } from 'config';
import Auth from 'api/auth';
import ErrorMessages from './ErrorMessages.vue';
import AuthForm from './AuthForm.vue';

export default {
  name: 'RequestAccess',
  components: {
    ErrorMessages,
    AuthForm,
  },
  computed: {
    titles() {
      return {
        send: this.$gettext("Demander l'accès à cette publication."),
        valid: this.$gettext('Valider votre demande'),
      };
    },
    successMsg() {
      return this.$gettextInterpolate(
        publicationAccessParameters.private_request_sent_message[this.$language.current],
        {
          appUrl,
        }
      );
    },
  },
  methods: {
    async requestAccess() {
      try {
        const data = await Auth.requestAccess(this.customMessage);
        this.customMessage = '';
        this.sent = true;
        this.$refs.requestAccessModal.hide();
      } catch (e) {
        const { data } = e.response;
        this.errors = data.error;
      }
    },
  },
  data() {
    return {
      sent: false,
      publicationAccessParameters,
      customMessage: '',
      errors: null,
      appUrl,
    };
  },
};
</script>
